import type { FaireProductEntity } from "../../entity_types/product";

export const p_wdkhe6p99p: FaireProductEntity = {
  token: "p_wdkhe6p99p",
  type: "product",
  name: 'Blu/Grn Rustic Style Mug-4"H(14oz)',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/3807a389fbc62627a150c866791283628b367577f2eb1da7baafce0c1d789cf3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/374f4d5d72fc3ab3ae04f8221ef97edd81c5f5c501072b715eecf60396557ca8.jpeg",
    "https://cdn.faire.com/fastly/cc37211d3ca150367ff548e21148a1a4451313260cb380063351033995dcaef4.jpeg",
    "https://cdn.faire.com/fastly/7e7fa0cacaca61b7ef55ec87ff497557afe415f7ed9d84d8647ae8c36d2c6e8d.jpeg",
    "https://cdn.faire.com/fastly/ce772f6b41610c57a7e9031833db949a288eb59e67bb4406479b3ae1b8c67c7c.jpeg",
  ],
  priceDollars: 8,
  description:
    "Add a fashion-forward touch to your kitchenware with this retro-chic Rustic Style Mug. Crafted out of stoneware, this blue-and-green mug features a wide base for spacious 14 oz. capacity — complemented by its simple yet striking design and vintage charm. Other colours also available.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:15.439Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
